import React from 'react';

/**
 * Host loader matching gaxl-web-foundation Loader geometry and animation.
 * Bars use Tailwind `bg-brand-primary` (foundation brand blue) — visible on
 * canvas/surface. Foundation's own Loader uses `--gaxl-brand-on-primary`
 * (white), which disappears on light backgrounds.
 */
export const Loader: React.FC<{ label?: string; 'data-testid'?: string }> = ({
  label,
  'data-testid': testId = 'loader',
}) => (
  <div
    data-testid={testId}
    className="relative flex h-full w-full flex-col items-center justify-center gap-3 p-6"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <div className="relative flex h-10 items-center justify-center" aria-hidden>
      <span className="gaxl-host-loader-bar inline-block h-5 w-[3px] rounded-[10px] bg-brand-primary" />
      <span className="gaxl-host-loader-bar gaxl-host-loader-bar--mid mx-[5px] inline-block h-[35px] w-[3px] rounded-[10px] bg-brand-primary" />
      <span className="gaxl-host-loader-bar gaxl-host-loader-bar--late inline-block h-5 w-[3px] rounded-[10px] bg-brand-primary" />
    </div>
    {label ? (
      <span className="text-sm text-text-secondary">{label}</span>
    ) : (
      <span className="sr-only">Loading…</span>
    )}
    <style>{`
      .gaxl-host-loader-bar {
        animation: gaxl-host-loader-scale-up 1s linear infinite;
      }
      .gaxl-host-loader-bar--mid { animation-delay: 0.25s; }
      .gaxl-host-loader-bar--late { animation-delay: 0.5s; }
      @keyframes gaxl-host-loader-scale-up {
        20% { transform: scaleY(1.5); }
        40% { transform: scaleY(1); }
      }
    `}</style>
  </div>
);
